module.exports = function () {
  processExternalReference();
  return processResize();
};

async function processResize () {
  const companyFactory = require('../factory/company').instance;
  const data = await companyFactory.getProjectData();

  return data.is_resizable &&
    !data.is_resized &&
    companyFactory.initialTemplateResize(data.format, data.name);
}

async function processExternalReference () {
  const urlParam = new URLSearchParams(window.location.search);
  const ref = urlParam.get('external_ref') || urlParam.get('external_reference');

  if (ref && ref !== INKIVE.C.BOOK.external_reference) {
    await INKIVE.SettingsFactory.set({ external_reference: ref })
    INKIVE.C.BOOK.external_reference = ref;
  }
}